import React, { useState,useEffect } from 'react';
import axios from 'axios';
import {
   Box, Typography, Select, MenuItem, BottomNavigation, BottomNavigationAction, TextField,
 Snackbar, Alert
} from '@mui/material';
import { useForm, Controller } from 'react-hook-form';
import globalStyles from '../../utils/globalStyles';
import uilityApi from '../../api/utility';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';


function BundleReportSheet() {
  const { control } = useForm({});
  const [exportDisble, setExportDisable] = React.useState(false);
  const [showLoader,setShowLoader] = React.useState(false);
  const [openAlert, setOpenAlert] = React.useState(false);
  const [exportError, setExportError] = React.useState(false);
  const [reportType, setReportType] = useState('all');
  const [oracleIds, setOracleIds] = useState('');
  const [selectDate, setSelectDate] = useState({ fromDate: null, toDate: null });

  useEffect(() => {
    const { fromDate, toDate } = selectDate;
  
    if (!fromDate || !toDate) {
      setExportDisable(true);
      return;
    }
  
    const normalizedFrom = new Date(fromDate);
    const normalizedTo = new Date(toDate);
    const today = new Date();
  
    normalizedFrom.setHours(0, 0, 0, 0);
    normalizedTo.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
  
    const isValidRange = normalizedTo <= today && normalizedTo >= normalizedFrom;
    setExportDisable(!isValidRange);
    if (openAlert && isValidRange) {
      setOpenAlert(false);
    }
  }, [selectDate, openAlert]);
  

  const handleFromDateChange = (date) => {
    setSelectDate((prev) => ({ ...prev, fromDate: date }));
    if (openAlert) setOpenAlert(false); 

  };

  const handleToDateChange = (date) => {
    setSelectDate((prev) => ({ ...prev, toDate: date }));
    if (openAlert) setOpenAlert(false); 

  };
  const handleErrorMsg = () => {
    setOpenAlert(true)
    setTimeout(() => {
        setOpenAlert(false)
    }, 5000)
};

  const closeAlert = () => {
    setOpenAlert(false)
  }
  
  const formatLocalDate = (date, isStart = true) => {
    if (!(date instanceof Date)) return null;
    const pad = (n) => n.toString().padStart(2, '0');
    const yyyy = date.getFullYear();
    const MM = pad(date.getMonth() + 1);
    const dd = pad(date.getDate());
    const hh = isStart ? '00' : '23';
    const mm = isStart ? '00' : '59';
    const ss = isStart ? '00' : '59';
    return `${yyyy}-${MM}-${dd} ${hh}:${mm}:${ss}`;
  };
  
 
  const handleExport = () => {
    const { fromDate, toDate } = selectDate;
  
    if (!fromDate || !toDate) {
      setExportDisable(false);
      setShowLoader(false);
      setExportError(true);
      setOpenAlert(true);
     // setTimeout(() => setOpenAlert(false), 3000);
      return;
    }
  
    const normalizedFromDate = new Date(fromDate);
    const normalizedToDate = new Date(toDate);
    const today = new Date();
  
    // Normalize all dates to ignore time
    normalizedFromDate.setHours(0, 0, 0, 0);
    normalizedToDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
  
    if (normalizedToDate > today || normalizedToDate < normalizedFromDate) {
      setExportDisable(false);
      setShowLoader(false);
      setExportError(true);
      setOpenAlert(true);
     // setTimeout(() => setOpenAlert(false), 3000);
      return;
    }
  
    setExportDisable(true);
    setShowLoader(true);
    setExportError(false);
    setOpenAlert(false);
  
    const exportPayload = {
      action: "BUNDLE_REPORT",
      filter: {
        fromDate: formatLocalDate(normalizedFromDate, true),
        toDate: formatLocalDate(new Date(normalizedToDate.getTime() + 86400000), true), // +1 day
      },
    };
  
    if (reportType === "custom" && oracleIds.trim() !== '') {
      exportPayload.filter["oracleIds"] = oracleIds
        .split(',')
        .map(id => id.trim())
        .filter(id => id);
    }
  
    axios.post(`${uilityApi.url}`, exportPayload)
      .then((res) => {
        const data = res.data?.data;
  
        if (!data || !Array.isArray(data) || data.length === 0) {
          throw new Error("No data received for export.");
        }
  
        const csvContent = data.map(row =>
          row.map(cell =>
            cell && typeof cell === 'string' && (cell.includes(',') || cell.includes('"'))
              ? `"${cell.replace(/"/g, '""')}"`
              : cell?.toString().trim() ?? ''
          ).join(',')
        ).join('\r\n');
  
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = `bundle_report_${Date.now()}.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
  
        setExportDisable(false);
        setShowLoader(false);
      })
      .catch((error) => {
        console.error('Error in export:', error);
        setShowLoader(false);
        setExportDisable(false);
        handleErrorMsg();
      });
  }
  

  return (
    <>
      {/* Error Snackbar */}
      <Snackbar
        open={openAlert}
        autoHideDuration={3000}
        onClose={closeAlert}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={closeAlert} severity="error" sx={{ width: '400px', marginTop: '100px' }}>
          An error occurred while exporting
        </Alert>
      </Snackbar>
  
      {/* Page Header */}
      <Box sx={globalStyles.headerWrapperBox}>
        <Box sx={{ width: '50%', display: 'flex', margin: '20px 30px' }}>
          <Typography variant="h4">Generate Bundle's Report Sheet</Typography>
        </Box>
      </Box>
  
      {/* Main Container */}
      <Box sx={globalStyles.headerWrapperBox}>
        <Box
          sx={{
            width: '70%',
            display: 'flex',
            flexDirection: 'column',
            gap: '20px',
            margin: '0px 90px',
            //margin: '0 auto', // ✅ Centers it horizontally

            padding: '20px',
            border: '1px solid #ccc',
            borderRadius: '10px',
            backgroundColor: '#f9f9f9',
          }}
        >
          {/* Report Type Selection */}
          {/* <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <Typography fontWeight={500}>Report Download For:</Typography>
            <Select
              value={reportType}
              onChange={(e) => setReportType(e.target.value)}
              sx={{
                width: '200px',
                border: '1px solid #2b3f7a',
                backgroundColor: '#fff',
                borderRadius: '5px',
              }}
            >
              <MenuItem value="all">All</MenuItem>
              <MenuItem value="custom">Custom</MenuItem>
            </Select> */}
  
            {/* Custom Input Field (Only Visible When Custom is Selected) */}
            {/* {reportType === 'custom' && (
              <TextField
                placeholder="Enter comma-separated Oracle IDs"
                value={oracleIds}
                onChange={(e) => setOracleIds(e.target.value)}
                multiline
                rows={2}
                sx={{
                  width: '35%',
                  border: '1px solid #2b3f7a',
                  borderRadius: '5px',
                  backgroundColor: '#fff',
                }}
              />
            )}
          </Box>
   */}
          {/* Date Range Selection */}
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <Typography fontWeight={500}>Filter by Date Range <Box component="span" sx={{ color: 'red' }}>*</Box></Typography>
            <Box sx={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
              <DatePicker
                selected={selectDate.fromDate}
                onChange={handleFromDateChange}
                selectsStart
                startDate={selectDate.fromDate}
                endDate={selectDate.toDate}
                isClearable
                placeholderText="From Date"
                dateFormat="yyyy-MM-dd"
                className="date-picker"
              />
              <DatePicker
                selected={selectDate.toDate}
                onChange={handleToDateChange}
                selectsEnd
                startDate={selectDate.fromDate}
                endDate={selectDate.toDate}
                //minDate={selectDate.fromDate}
                minDate={selectDate.fromDate || null}
                maxDate={new Date()} 
                isClearable
                placeholderText="To Date"
                dateFormat="yyyy-MM-dd"
                className="date-picker"
              />
            </Box>
          </Box>
          {openAlert && (
        <Alert severity="error" onClose={closeAlert} sx={{ my: 2 }}>
          Please select a valid date range.
        </Alert>
      )}
          {/* Export Button */}
          <Box sx={{ textAlign: 'right' }}>
            <BottomNavigation showLabels sx={globalStyles.bottomNavigationExport}>
              <BottomNavigationAction 
               sx={{
                opacity: exportDisble ? 0.8 : 1,
                pointerEvents: exportDisble ? 'none' : 'auto',
              }}
            
                label={
                  <Box sx={globalStyles.exportLabel}>
                    {showLoader ? (
                      <>
                        Exporting&nbsp;&nbsp;
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      </>
                    ) : (
                      'Export'
                    )}
                  </Box>
                }
                disabled={exportDisble}
                onClick={handleExport}
              />
            </BottomNavigation>
          </Box>
        </Box>
      </Box>
    </>
  );
  
  
}

export default BundleReportSheet;